import React from 'react';
import Loadable from 'react-loading-overlay';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import { WorkerForm } from '../WorkerForm';
import Row from '../../../../shared/components/Row';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { WorkerDetailTask } from './worker-detail/WorkerDetailTask';
import { WorkerDetailRequest } from './worker-detail/WorkerDetailRequest';
import { PsWorker } from '../../PsWorker';
import { WorkerFormValues } from '../WorkerFormValues';
import DocumentsCard from '../../../../documents/components/DocumentsCard';
import StateManager from '../../../../shared/utils/StateManager';
import CardMessages from '../../../../messages-notifications/messages/to-refactor/card/CardMessages';
import { WorkerUpdateRequest } from './worker-update/WorkerUpdateRequest';
import { WorkerUpdateTask } from './worker-update/WorkerUpdateTask';
import { bindActionCreators } from 'redux';
import * as navigationActions from '../../../../shared/utils/NavigationActions';
import { connect } from 'react-redux';
import { CurrentUser } from '../../../../shared/model/CurrentUser';
import UserRole from '../../../../shared/model/UserRole';

class WorkerUpdate extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            worker: null,
            loading: false,
            workerInitialValues: WorkerFormValues.null(),
            refreshDocuments: false,
            refreshQrToken: false,
            qrTokenLoading: false,
        };
    }

    componentDidMount() {
        this.getWorker();
    }

    handleSetRefreshDocuments = (refresh) => {
        this.setState({ refreshDocuments: refresh });
    };

    handleSetRefreshQrToken = (refresh) => {
        this.setState({ refreshQrToken: refresh });
    };

    handleTokenLoading = (loading) => {
        this.setState({ qrTokenLoading: loading });
    };

    render() {
        const {
            worker,
            loading,
            workerInitialValues,
            refreshDocuments,
            refreshQrToken,
            qrTokenLoading,
        } = this.state;

        if ( !worker ) return null;

        const workerId = worker.id();
        const workerCompanyId = worker.companyId();
        const initialValues = workerInitialValues.initialValues();

        return (
            <React.Fragment>
                <Row clearfix>
                    <WorkerForm
                        title={I18nUtils.tr('TR_EDITAR_TRABAJADOR')}
                        initialValues={initialValues}
                        workerId={workerId}
                        onSubmit={this.updateWorker}
                        handleSetRefreshQrToken={this.handleSetRefreshQrToken}
                        refreshQrToken={refreshQrToken}
                        handleTokenLoading={this.handleTokenLoading}
                        loading={loading || qrTokenLoading}
                        contractorManagerDisabledFields={ this.props.currentUserRole === UserRole.CONTRACTORS_MANAGER }
                    />
                </Row>
                <DocumentsCard
                    id={StateManager.DOC_WORKER_DETAIL_ID + workerId}
                    title={I18nUtils.tr('TR_DOCUMENTOS')}
                    workerId={workerId}
                    hideOutsource={true}
                    asSubcontracted={true}
                    refreshDocuments={refreshDocuments}
                    handleSetRefreshDocuments={this.handleSetRefreshDocuments}
                    displayContractorColumn={true}
                />
                <Row clearfix>
                    <CardMessages
                        workerId={workerId}
                        companyId={workerCompanyId}
                        colWidth="col-md-12"
                        canAddMessage={true}
                        canResponseMessage={true}
                    />
                </Row>
            </React.Fragment>
        );
    }

    getWorker = () => {
        const { id, appendBreadcrumb } = this.props;
        const request = new WorkerDetailRequest();

        request.setId(id);

        new WorkerDetailTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                const worker = PsWorker.fromAPIWorker(res.data);
                const workerInitialValues = WorkerFormValues.fromWorker(worker);
                appendBreadcrumb(worker);
                this.setState({ worker, workerInitialValues });
            })
            .onFail((error) => {
                Alert.error(error);
                this.setState({ loading: false });
            })
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };

    updateWorker = (values) => {
        const {
            worker,
            workerInitialValues,
        } = this.state;

        // comprobación de si ha cambiado un esquema para refrescar el listado de documentos
        let needsRefreshDocuments = false;
        const initialValues = workerInitialValues.initialValues();
        if (initialValues.contractorSchemas.length === 0 && values.contractorSchemas.length !== 0) {
            needsRefreshDocuments = true;
        } else {
            initialValues.contractorSchemas.forEach((contractorSchema, index) => {
                if ( ( !needsRefreshDocuments &&
                        values.contractorSchemas[index].schema.length !== contractorSchema.schema.length ) ||
                    values.contractorSchemas[index].schema[0] !== contractorSchema.schema[0] ) {
                    needsRefreshDocuments = true;
                }
            });
        }

        this.setState({ loading: true });
        const request = new WorkerUpdateRequest(values, worker);
        new WorkerUpdateTask(request)
            .onSuccess(() => {
                this.setState({ loading: false });
                Alert.success(I18nUtils.tr('TR_TRABAJADOR_EDITADO_CORRECTAMENTE'));
                if ( needsRefreshDocuments ) {
                    this.handleSetRefreshDocuments(true);
                }
                this.handleSetRefreshQrToken(true);
            })
            .onFail((error) => {
                Alert.error(error);
                this.setState({ loading: false });
            })
            .execute();
    };
}

const mapStateToProps = (state) => {
    const currentUserRole = CurrentUser.fromReduxState(state).role();
    return { currentUserRole };
};

const mapDispatchToProps = (dispatch) => ( { navigation: bindActionCreators(navigationActions, dispatch) } );

export const WorkerUpdateContent = connect(mapStateToProps, mapDispatchToProps)(WorkerUpdate);

WorkerUpdateContent.propTypes = {
    id: PropTypes.number.isRequired,
    appendBreadcrumb: PropTypes.func,
};

WorkerUpdateContent.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/form/update/WorkerUpdateContent.jsx